import axios from 'axios';

const api = axios.create({
  // Vercel will inject REACT_APP_API_URL as your Render backend URL
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api', 
  withCredentials: true
});

// Request interceptor
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor
api.interceptors.response.use(
  response => {
    const newToken = response.headers['new-access-token'];
    if (newToken) {
      localStorage.setItem('token', newToken);
    }
    return response;
  },
  async error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;